import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getFollowProfile, getUserProfile } from "../../../redux/hire/action";
import {
  formatNumberWithCommas,
  getMemberSince,
  getTime,
} from "../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import Access from "../../CustomComponents/Access/Access";
import ImageWithFallback from "../../../common/ImageWithFallback";
import HTMLContents from "../../Common/HTMLContents";
import WorkingDayComponent from "../../Common/WorkingDayComponent";
import WorkingHourComponent from "../../Common/WorkingHourComponent";
import StarRatingComponent from "../../Common/StarRatingComponent";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";
import DisplayFileProper from "../../Common/FilesRelevent/DisplayFileProper";
import RatingReviewsComponent from "../../Common/RatingReviewsComponent";
import YearRange from "../../Common/YearRange";
import { decodeHtml } from "../../../assests/extention/commonfunction";

export default function ExpertsProfileDetails() {
  const { id } = useParams();
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [modalOpen, setModalOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const formData = useSelector(
    ({ hire: { getuserprofile } }) => getuserprofile
  );
  const getfollowprofile = useSelector(
    ({ hire: { getfollowprofile } }) => getfollowprofile
  );
  const edittype = 2;
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(getUserProfile(id));
    }
  }, [id]);

  const letFollow = () => {
    dispatch(getFollowProfile(id));
  }

  const letChat = (item) => {
    const data = {
      post_id: formData?.id,
      user_id: formData?.user_id,
    };
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const hiringpermissioncheck = () => {
    navigate(`/${lan}/youexperthiring/${formData?.id}`);
  };

  const savedState = JSON.parse(localStorage.getItem("newTabState"));
  console.log(savedState, 'saved state in profile details');


  const flattenSubcategories = (categories) => {
    return categories?.flatMap((category) =>
      category.sub_categories.map((sub) => ({
        ...sub,
        categoryId: category.id,
        categoryTitle: category.title,
      }))
    );
  };

  const subcategoryArray = flattenSubcategories(formData?.categories);

  return (
    <div className="hire-details col-lg-10 mx-auto">
      {modal && (
        <Access
          modal={modal}
          setModalOpen={setModalOpen}
          setModal={setModal}
          checkpermission="hiring"
          type="hiring"
          hitmethod={hiringpermissioncheck}
          checkrole={false}
        />
      )}

      <p className="breadcrumbs">
        <a
          onClick={() => {
            savedState?.industry_id == 0 ? navigate(`/${lan}/searchall?type=${savedState?.type || 1}`) :
              navigate(`/${lan}/hireexpertsbycategory/${savedState?.industry_id}`)
          }
          }
        >
          {decodeHtml(savedState?.industry_name)} &gt;{" "}
        </a>
        <a
          onClick={() => {
            savedState?.industry_id == 0 ? navigate(-1) :
              navigate(`/${lan}/filterandhirexperts`, {
                state: { indcatsub: savedState },
              })
          }
          }
        >
          {decodeHtml(savedState?.category_name)} &gt;
        </a>
        {savedState?.industry_id == 0 ? "Client Profile" : "Profile details"}
      </p>
      <div className="expertdetail-first">
        <div className="expertdetail-row">
          <div className="expert-left">
            <ProfileImageWithFallback url={formData?.profile_image} className="" />
            <div>
              <h2 className="manage-head">
                {decodeHtml(formData?.first_name)} {decodeHtml(formData?.last_name)}
              </h2>
              <h6>
                {formData?.expert ? decodeHtml(formData?.expert?.designation) : ""}
                {formData?.company ? decodeHtml(formData?.company?.cr_number) : ""}
                <span>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                    alt=""
                  />
                  {decodeHtml(formData?.country_title)}
                </span>
              </h6>
            </div>
          </div>
          <div className="expert-right">
            <button
              className="btn active message-btn"
              onClick={() => letFollow()}
            >
              {formData?.following == 1 ? "Unfollow" : "Follow"}
            </button>

            <button
              className="btn message-btn"
              onClick={() => letChat(formData)}
            >
              Message
            </button>
            {
              formData?.role_type == 2 ? "" :
                <button
                  className="btn active message-btn"
                  onClick={() => setModal(true)}
                >
                  Hire {formData?.company ? "Company" : "Expert"}
                </button>
            }
          </div>
        </div>
      </div>
      <div className="manage-profile">
        <div className="expertdetail-second col-md-12">
          <div className="row">
            <div className="col-lg-3 col-md-4 expert-second-left d-flex flex-column" style={{ rowGap: '10px' }}>

              {Array.isArray(formData?.industries) &&
                <div className="about-expert">
                  <h6>
                    Industry, Category & Subcategory
                  </h6>
                  <p>
                    <h6>Industry : </h6>
                    {formData?.industries?.map((item, index) => (
                      <>
                        <p key={index}>{decodeHtml(item?.title)}</p>
                      </>
                    ))}
                  </p>
                  <p>
                    <h6>Category : </h6>
                    {formData?.categories?.map((item, index) => (
                      <>
                        <p key={index}>{decodeHtml(item?.title)}</p>
                      </>
                    ))}
                  </p>
                  <p>
                    <h6>Subcategory : </h6>
                    {subcategoryArray?.map((item, index) => (
                      <>
                        <p key={index}>{decodeHtml(item?.title)}</p>
                      </>
                    ))}
                  </p>
                </div>}
              {formData?.language &&
                <div className="about-expert">
                  <h6>language</h6>
                  {Array.isArray(formData?.language) &&
                    formData?.language?.map((item, index) => (
                      <p>
                        {item?.language_title} - {item?.proficiency_title}
                      </p>
                    ))}
                </div>}
              {(formData?.expert || formData?.iam == 1) && (
                <div className="about-expert">
                  <h6>Academic info</h6>
                  {Array.isArray(formData?.education) &&
                    formData?.education?.map((item, index) => (
                      <>
                        <p>
                          {item?.field} - {item?.university}
                        </p>
                        <p>
                          {item?.from_year} - {item?.to_year}
                        </p>
                      </>
                    ))}
                </div>
              )}
              {(formData?.expert || formData?.iam == 1) && (
                <div className="about-expert">
                  <h6>Employment </h6>
                  {Array.isArray(formData?.experience) &&
                    formData?.experience?.map((item, index) => (
                      <>
                        <p>
                          {decodeHtml(item?.designation)} - {decodeHtml(item?.company)}
                        </p>
                        <YearRange fromYear={item?.from_year} toYear={item?.to_year} />
                      </>
                    ))}
                </div>
              )}
              {formData?.expert && (
                <div className="about-expert">
                  <h6>Charges </h6>
                  <p>
                    $
                    {formData?.expert
                      ? formData?.expert?.price_per_hour
                      : formData?.price_per_hour}
                    /hour
                  </p>
                  <p>
                    $
                    {formData?.expert
                      ? formData?.expert?.price_per_month
                      : formData?.price_per_month}
                    /month
                  </p>
                </div>
              )}
              {formData?.company && (
                <div className="about-expert">
                  <h6>Charges </h6>
                  <p>
                    $
                    {formData?.company
                      ? formData?.company?.price_per_hour
                      : formData?.price_per_hour}
                    /hour
                  </p>
                  <p>
                    $
                    {formData?.company
                      ? formData?.company?.price_per_month
                      : formData?.price_per_month}
                    /month
                  </p>
                </div>
              )}
              {formData?.preferences?.working_days && formData?.preferences?.working_days?.length &&
                <div className="about-expert">
                  <h6>
                    Working Days
                  </h6>
                  <WorkingDayComponent formData={formData} />
                </div>
              }
              {Array.isArray(formData?.working_hours) && formData?.working_hours?.length > 0 &&
                <div className="about-expert">
                  <h6> Working Hour  </h6>
                  <WorkingHourComponent formData={formData} />
                </div>
              }
            </div>

            <div className="col-lg-9 col-md-8 expert-second-right">
              <div className="members">
                <p>Member since {getMemberSince(formData?.created_on)} {"   "}{"   "}
                <span style={{
                    minWidth: 'max-content',
                    justifyContent: 'unset',
                    maxWidth: '100%'
                }}>{"   "}
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/verified.svg`}
                        alt=""
                    />{"   "}
                    Verified
                </span>
                </p>
            </div>
              {formData?.role_type == 2 ? "" :
                <h4 className="about-me pb-4">
                  {formData?.company || formData?.iam == 2
                    ? "About Company"
                    : "About Expert"}
                </h4>
              }
              {formData?.expert && (
                <>
                  <HTMLContents data={formData?.expert ? formData?.expert?.about : formData?.about} />
                  <p>Designation</p>
                  <p>
                    {decodeHtml(formData?.expert
                      ? formData?.expert?.designation
                      : formData?.designation)}
                  </p>
                </>
              )}
              {edittype == 2 && formData?.iam == 1 && (
                <>
                  <h4 className="d-flex justify-content-between align-items-center">
                    About Expert
                  </h4>
                  <HTMLContents data={formData?.expert ? formData?.expert?.about : formData?.about} />
                  <h4>Designation</h4>
                  <h4>
                    {decodeHtml(formData?.expert
                      ? formData?.expert?.designation
                      : formData?.designation)}
                  </h4>
                </>
              )}
              {(formData?.company || formData?.iam == 2) && (
                <>

                  {/* {
                    JSON.stringify(formData?.company)
                  } */}
                  {/* <h4 className="d-flex justify-content-between align-items-center">
                    About details
                  </h4> */}
                  <p className="about-me about-font"> Company Name  : <span> {decodeHtml(formData?.company?.company_name)}</span></p>
                  <p className="about-me about-font">CR Number :  <span>{formData?.company?.cr_number}</span></p>
                  <p className="about-me about-font"> Website URL : <span>{formData?.company?.website_link}</span></p>
                  <div className="expert-sub-sec">
                    <div className="expert-heading">
                      <h6 className="d-flex justify-content-between align-items-center">
                        About company
                      </h6>
                    </div>
                    <HTMLContents data={formData?.company ? formData?.company?.about : formData?.about} />
                  </div>
                </>
              )}

              {(formData?.company || formData?.iam == 2) && (
                <div className="expert-sub-sec">
                  <div className="expert-heading">
                    <h6>Industries </h6>
                  </div>
                  <div className="skills">
                    {Array.isArray(formData?.industries) &&
                      formData?.industries?.map((item, index) => (
                        <p key={index}>{item?.title}</p>
                      ))}
                  </div>
                </div>
              )}
              {Array.isArray(formData?.skills) &&
                <div className="expert-sub-sec">
                  <div className="expert-heading">
                    <h6>Competencies </h6>
                  </div>
                  <div className="skills">
                    {
                      formData?.skills?.map((item, index) => (
                        <p>{decodeHtml(item?.title)}</p>
                      ))}
                  </div>
                </div>
              }
              {Array.isArray(formData?.work_sample) &&
                formData?.work_sample?.length > 0 && (
                  <div className="expert-sub-sec">
                    <div className="expert-heading">
                      <h6>Work samples</h6>
                      {edittype == 1 && (
                        <button
                          className="btn"
                          onClick={() =>
                            navigate(`/${lan}/dashboard/manageportfolio`)
                          }
                        >
                          View all
                        </button>
                      )}
                    </div>
                    <div className="row" style={{ rowGap: "30px" }}>
                      {Array.isArray(formData?.work_sample) &&
                        formData?.work_sample?.map((item, index) => (
                          <div key={index} className="col-lg-4 col-md-6  expert-img"
                            onClick={() => { navigate(`/${lan}/worksample/${item?.id}`) }}
                          >
                            <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                            <h5>{decodeHtml(item?.title)}</h5>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              {Array.isArray(formData?.bxp) && formData?.bxp?.length > 0 && (
                <div className="expert-sub-sec">
                  <div className="expert-heading">
                    <h6>One time service (OTS)</h6>
                    {edittype == 1 && (
                      <button
                        className="btn"
                        onClick={() =>
                          navigate(`/${lan}/dashboard/myotsproducts`)
                        }
                      >
                        View all
                      </button>
                    )}
                  </div>
                  <div className="row exp-row">
                    {Array.isArray(formData?.bxp) &&
                      formData?.bxp?.map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6  expert-img" onClick={() => { navigate(`/${lan}/packageddetails/${item.id}`); }}>
                          <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                          <h5>{decodeHtml(item?.title)}</h5>
                          <CustomReactQuillDescription
                            value={item.description}
                          />
                          <h5>$ {formatNumberWithCommas(item?.price)}</h5>
                        </div>
                      ))}
                  </div>
                </div>
              )}

              <RatingReviewsComponent formData={formData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
